// latest: zhangmyh 2017-2-23 7:34 PM
import { Collection } from 'common'
import 'model/evaluationGroup/evalGroupRefer'

Collection.define('evalgroup.referlist', {
  model: 'evalgroup.refer',
  proxy: {
    get: '/cpu-supplymgr/supplyMgrEvaluate/evaluateGroup/selectByParentId'
  }
})

export default Collection.create('evalgroup.referlist')



// WEBPACK FOOTER //
// ./src/data/collection/evaluationGroup/evalGroupRefer.js